export const EditedIcon = ({ color, onClick }) => {
    return (
      <svg
        onClick={onClick}
        width="22"
        height="22"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.15733 16.3588L5.15735 16.3588L5.19001 16.3507L5.19003 16.3507L7.1448 15.862C7.16204 15.8577 7.1794 15.8534 7.19687 15.849C7.41093 15.796 7.6411 15.7389 7.8513 15.6199C8.0615 15.5009 8.22884 15.3329 8.38448 15.1766C8.39718 15.1639 8.40981 15.1512 8.42237 15.1386L14.2807 9.28033L14.2807 9.28032L14.2962 9.26474L14.3046 9.25639C14.5383 9.02275 14.7528 8.80829 14.9119 8.61226C15.0846 8.39936 15.2468 8.14439 15.3071 7.81743C15.3458 7.60758 15.3458 7.39242 15.3071 7.18257C15.2468 6.85561 15.0846 6.60064 14.9119 6.38774C14.7528 6.19171 14.5383 5.97724 14.3046 5.7436L14.2807 5.71967L14.2568 5.69576C14.0231 5.46207 13.8086 5.24755 13.6126 5.08847C13.3997 4.91572 13.1447 4.75355 12.8178 4.69324C12.6079 4.65454 12.3927 4.65454 12.1829 4.69324C11.8559 4.75355 11.601 4.91572 11.3881 5.08847C11.192 5.24755 10.9776 5.46205 10.7439 5.69574L10.72 5.71967L4.86171 11.578C4.84915 11.5905 4.83648 11.6031 4.82373 11.6158C4.66747 11.7715 4.49946 11.9388 4.38044 12.149L5.03309 12.5186L4.38044 12.149C4.26143 12.3592 4.20437 12.5894 4.15131 12.8035C4.14697 12.8209 4.14267 12.8383 4.13836 12.8555L3.6415 14.843C3.63888 14.8534 3.63621 14.8641 3.63349 14.8749C3.59566 15.0257 3.54929 15.2106 3.53364 15.3705C3.51596 15.5512 3.51438 15.9078 3.80348 16.1968C4.09257 16.4859 4.44908 16.4844 4.62979 16.4667C4.78973 16.451 4.97457 16.4047 5.12536 16.3668C5.1362 16.3641 5.14687 16.3614 5.15733 16.3588Z"
          stroke="#67809A"
          stroke-width="1.5"
        />
        <path
          d="M10.417 6.25L13.7503 9.58333"
          stroke="#67809A"
          stroke-width="1.5"
        />
      </svg>
    );
  };